import { useEffect } from 'react';
import { db } from '../db';

export function useHistoryCleanup() {
  useEffect(() => {
    // Handle tab/window close
    const handleBeforeUnload = () => {
      db.clearHistory();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup function
    return () => {
      handleBeforeUnload();
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
}
